export default class Hideable {
	constructor(element, hiddenOnStart = false, duration = 300) {
		this.element = element;
		this.duration = duration;
		this.shouldShow = !hiddenOnStart;
		this.shouldHide = hiddenOnStart;

		hiddenOnStart ? this.hide() : this.show();
	}

	show() {
		this.element.style.display = 'block';
		this.shouldShow = true;
		this.shouldHide = false;

		// Cancel the race condition for a smooth animation
		setTimeout(() => {
			if (this.shouldShow) this.element.style.opacity = '1';
		}, 0);
	}

	hide() {
		this.element.style.opacity = '0';
		this.shouldShow = false;
		this.shouldHide = true;

		setTimeout(() => {
			if (this.shouldHide) this.element.style.display = 'none';
		}, this.duration);
	}
}
